import { t as ZepIcon } from "../ZepIcon-DpJgyrAI.mjs";
import { jsx } from "react/jsx-runtime";
// src/components/CheckFlowerFill.tsx
const CheckFlowerFillIcon = ZepIcon((props) => /* @__PURE__ */ jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: /* @__PURE__ */ jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12.01 2.012a3.2 3.2 0 0 0-2.267.942l-.002.001-.696.696v.001A1.2 1.2 0 0 1 8.2 4h-1A3.2 3.2 0 0 0 4 7.2v1a1.2 1.2 0 0 1-.348.844v.001l-.697.696v.002a3.2 3.2 0 0 0 0 4.535v.002l.696.696h.001a1.2 1.2 0 0 1 .348.845v1a3.2 3.2 0 0 0 3.2 3.2h1c.316 0 .62.126.845.349l.696.696h.001a3.2 3.2 0 0 0 4.536 0h.002l.696-.696v-.001a1.2 1.2 0 0 1 .845-.349h1a3.2 3.2 0 0 0 3.2-3.2v-.999c0-.316.125-.62.348-.845l.697-.696v-.002a3.2 3.2 0 0 0 0-4.536l-.697-.697a1.199 1.199 0 0 1-.349-.845v-1a3.2 3.2 0 0 0-3.2-3.2h-1c-.315 0-.619-.125-.843-.348h-.001l-.696-.697h-.002a3.201 3.201 0 0 0-2.268-.943Zm3.788 8.32a.8.8 0 1 0-1.196-1.063l-3.668 4.127-1.536-1.727a.8.8 0 1 0-1.195 1.063l2.133 2.4a.8.8 0 0 0 1.196 0l4.266-4.8Z",
		fill: props.fill || "currentColor"
	})
}));
export { CheckFlowerFillIcon };
